import { render, staticRenderFns } from "./customArticle.module.vue?vue&type=template&id=69410c30&scoped=true"
import script from "./customArticle.module.vue?vue&type=script&lang=js"
export * from "./customArticle.module.vue?vue&type=script&lang=js"
import style0 from "./customArticle.module.vue?vue&type=style&index=0&id=69410c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69410c30",
  null
  
)

export default component.exports